const withFractionFormatter = new Intl.NumberFormat('cs-CZ', {
	style: 'currency',
	currency: 'CZK',
})
const noFractionFormatter = new Intl.NumberFormat('cs-CZ', {
	style: 'currency',
	currency: 'CZK',
	maximumFractionDigits: 0,
})

export function CurrencyFormatter({
	value,
	fractions = true,
}: {
	value?: string | number
	fractions?: boolean
}) {
	if (value === '' || value == null) return null

	const valueAsNumber = typeof value === 'string' ? parseFloat(value) : value
	const formatter = fractions ? withFractionFormatter : noFractionFormatter
	return <>{formatter.format(valueAsNumber)}</>
}
